"use client";
import { CardTypes, GridColumns, PageTypes } from "@/types/enums";
import DOMPurify from "isomorphic-dompurify";
// Components
import { CustomGrid } from "@/components/layout/grid";
import { Card, CardProps } from "@/components/molecules/card";
import { chakra, Grid, GridItem, Heading } from "@chakra-ui/react";
// Styels
import { ComponentProps } from "@/baseComponents";
import { useState } from "react";
import styles from "../../molecules/richTextComponent/richTextComponent.module.scss";
import ContactCard from "@/components/molecules/contactCard/ContactCard";

export interface CardGridProps extends ComponentProps {
  items?: CardProps[];
  title?: string;
  gridColumns?: GridColumns;
  pageContentType?: PageTypes;
  hideOverviewPublicationDate?: boolean;
}

export default chakra(CardGrid);
function CardGrid({
  items,
  title,
  gridColumns,
  hideOverviewPublicationDate = false,
  theme = "brand",
}: CardGridProps) {
  // States
  const colSpan = (): number => {
    if (gridColumns === GridColumns.One) return 12;
    else if (gridColumns === GridColumns.Two) return 6;
    else return 4;
  };

  // State to track the index of the hovered card
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <CustomGrid w="full">
      <GridItem colSpan={12} minWidth={{ lg: 64 }}>
        {title && (
          <Heading
            as={"h2"}
            fontSize={{ base: "2xl", md: "2rem", lg: "5xl" }}
            fontWeight={400}
            color={"brand.aubergine"}
            className={styles.title}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(title.replace(/<\/p>/g, "</br>"), {
                ALLOWED_TAGS: ["strong", "br"],
              }),
            }}
          />
        )}
      </GridItem>
      <GridItem colSpan={12} colStart={1}>
        {/* START Card Grid  */}
        <Grid
          templateColumns="repeat(12, 1fr)"
          gap={{
            base: items?.some((item) => item.cardType === CardTypes.Person)
              ? "2"
              : 0,
            md: "10",
          }}
        >
          {items &&
            items.map((item, index) => {
              return (
                <GridItem
                  key={index}
                  colSpan={{ base: 12, lg: colSpan() }}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  style={
                    item.cardType !== CardTypes.Person
                      ? {
                          transition: "opacity 0.3s ease",
                          opacity:
                            hoveredIndex === null || hoveredIndex === index
                              ? 1
                              : 0.4,
                        }
                      : undefined
                  }
                >
                  {item.cardType === CardTypes.Person ? (
                    <ContactCard
                      title={item.title}
                      text={item.text}
                      cardType={item.cardType}
                      mediaData={item.mediaData}
                      contactLinks={item.contactLinks}
                      isThreeGrid={gridColumns === GridColumns.Three}
                    />
                  ) : (
                    <Card
                      link={item.link}
                      title={item.title}
                      text={item.text}
                      cardType={item.cardType}
                      mediaData={item.mediaData}
                      tag={item.tag}
                      contactLinks={item.contactLinks}
                      date={item.date}
                      percentage={item.percentage}
                      hideOverviewPublicationDate={hideOverviewPublicationDate}
                    />
                  )}
                </GridItem>
              );
            })}
        </Grid>
        {/* END Card Grid  */}
      </GridItem>
    </CustomGrid>
  );
}
